import { toast } from "react-toastify";
import axiosInsatnace from "./apiClient";

class ApiService {
    
    async get(endpoint) {
        try {
            const response = await axiosInsatnace.get(endpoint);
            if (response.status === 200 || response.status === 201) {
                return response.data;
            } else {
                toast.error(`Unexpected response status: ${response.status}`)
            }
           
        } catch (error) {
           this.handleError(error);
        }
    }

    handleError(error) {
        toast.error('An error occurred while fetching data.');
        throw error;
    }
}
export default new ApiService();